export const ACTIVITY_STATUS = {
    ENABLED: 'enabled',
    SCHEDULED: 'scheduled',
    DISABLED: 'disabled',
    COMPLETED: 'completed',
    MISSED: 'missed',
    NO_SHOW: 'no_show',
    CANCELLED: 'cancelled',
} as const;

export type TActivityStatus = typeof ACTIVITY_STATUS[keyof typeof ACTIVITY_STATUS];
